export default __webpack_public_path__ + "static/media/no-records.2c212bcd.jpg";